module.exports = __webpack_public_path__ + "static/media/scoreboard-bg.db9a2d79.jpg";